<template>
  <div class="season">
    <loading-state :state="state"></loading-state>
    <div v-if="player">
      <div class="title-and-tools">
        <h2>{{player.full_name}}'s Stats</h2>
        <div class="tools"> 
          <div
            class="boxes compact width30"
            v-if="appState.fantasy.showEdit"
          >
            <fantasy-add-to-team-button
              :playerKey="playerKey"
            ></fantasy-add-to-team-button>
          </div>
        </div>
      </div>

      <section>
        <dl class="dl-tableview">
          <dt>Card Name</dt>
          <dd>{{player.card_name}}</dd>
          <template v-if="player.batting_styles && player.batting_styles.length">
            <dt>Batting Style</dt>
            <dd>{{player.batting_styles | join}}</dd>
          </template>
          <template v-if="player.bowling_styles && player.bowling_styles.length">
            <dt>Bowling Style</dt>
            <dd>{{player.bowling_styles | join}}</dd>
          </template>
          <template v-if="player.role">
          <dt>Role</dt>
          <dd>{{player.role.key | capitalise}}</dd>
          </template>
          <dt>Recent Teams</dt>
          <dd>
            <span
              class="tag"
              v-for="team in player.recent_teams"
              :key="team.key"
            >
            <router-link class="clean all"
              :to="{name: 'cricketTeam', params:{key: team.key}}">
              {{team.name}}
            </router-link>
            </span>
          </dd>
        </dl>
      </section>

      <div class="sub-menu sticky fixleft forlink">
        <ul>
          <li
          :class="{active:appState.activePage === 'cricket_player_'+playerKey+'_stats'}">
            <router-link class="clean all"
              :to="{name: 'cricketPlayerStats', params:{key: playerKey}}">
              Stats
            </router-link>
          </li>
          <li
          :class="{active:appState.activePage === 'cricket_player_'+playerKey+'_performance'}">
            <router-link class="clean all"
              :to="coverageSelected.buildUrl('cricketPlayerPerformance', playerKey)">
              Performance
            </router-link>
          </li>
          <li
          :class="{active:appState.activePage === 'cricket_player_'+playerKey+'_timeline'}">
            <router-link class="clean all"
              :to="coverageSelected.buildUrl('cricketPlayerTimeline', playerKey)">
              Timeline
            </router-link>
          </li>
        </ul>
      </div>

      <div>
        <router-view></router-view>
      </div>

    </div>
  </div>
</template>
<script>
import { CricketPlayer, CricketPlayerState } from '@/models/cricket/player'
import { CricketCoverage } from '@/models/cricket/core'
import { DataState, AppState } from '@/state'
import Utils from '@/utils'

export default {
  name: 'playerStats',
  data () {
    return {
      coverageSelected: CricketCoverage.State.selected,
      playerKey: this.$route.params.key,
      player: null,
      state: DataState.newLoading(),
    }
  },
  watch: {
    '$route' (to, from) {
      if (to.params.key !== from.params.key) {
        this.prepareToReopen()
        this.onViewOpenned()
      } else {
        this.refreshView()
      }
    }
  },
  mounted () {
    this.onViewOpenned()
  },
  methods: {
    onViewOpenned () {
      this.playerKey = this.$route.params.key
      const newTitle = 'loading...'
      AppState.updateActivePage(`cricket_player_${this.playerKey}`)
      AppState.updateTitles(newTitle, newTitle)

      CricketPlayer.fetchProfile(this.playerKey).then(player => {
        console.log('Profile Loaded')
        this.player = player
        const newTitle = `${this.player.name}`
        AppState.updateTitles(newTitle, newTitle)
        CricketPlayer.State.selected = this.player

        this.state.changeToLoaded()
      }).catch((error) => {
        console.error(error)
        this.state.changeToError(error)
      })
    },
    prepareToReopen () {
      this.playerKey = null
      this.player = null
    },
    refreshView () {

    },
  }
}
</script>
